import { isFromEditsBucket } from '@air/feature-edit-canvas';

export const isPreviewSrc = (src: string | undefined): boolean => {
  if (!src) {
    return false;
  }

  return isFromEditsBucket(src) || src.startsWith('data:') || src.startsWith('blob:');
};
